import * as Dialog from "@radix-ui/react-dialog";
import { ArrowUpRight, X } from "lucide-react";
import { TEADM_STORES } from "@/content/locations";
import { LINKS } from "@/content/site";

const StoreRow = ({ loc, i }) => (
  <a
    href={loc.orderUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`order-modal-${loc.slug}`}
    className="group flex items-center gap-4 rounded-3xl bg-white p-3 pr-5 transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl"
  >
    <span className="grid h-16 w-16 shrink-0 place-items-center overflow-hidden rounded-2xl" style={{ background: loc.color }}>
      <img src={loc.image} alt="" className="h-14 w-auto object-contain" />
    </span>
    <span className="min-w-0 flex-1">
      <span className="block font-display text-lg font-extrabold leading-tight">{loc.name}</span>
      <span className="block truncate text-sm text-[#1a0a10]/70">{loc.street}, {loc.city}</span>
    </span>
    <span className="font-display text-xs font-bold text-[#1a0a10]/50">0{i + 1}</span>
    <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
  </a>
);

export const OrderModal = ({ open, onOpenChange }) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-[100] bg-[#1a0a10]/60 backdrop-blur-md data-[state=open]:animate-in data-[state=open]:fade-in-0" />
      <Dialog.Content
        data-lenis-prevent
        data-testid="order-modal"
        className="fixed inset-x-3 bottom-3 z-[101] max-h-[88svh] overflow-y-auto rounded-[2rem] bg-[#fff5e8] p-5 sm:inset-x-auto sm:left-1/2 sm:top-1/2 sm:bottom-auto sm:w-[560px] sm:-translate-x-1/2 sm:-translate-y-1/2 sm:p-8 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-bottom-8"
      >
        <div className="mb-6 flex items-start justify-between gap-4">
          <div>
            <p className="eyebrow text-[#ff2e63]">Order online · Toast</p>
            <Dialog.Title className="mt-2 font-display text-3xl font-extrabold leading-none sm:text-4xl">Pick your TeaDM</Dialog.Title>
            <Dialog.Description className="mt-2 text-sm text-[#1a0a10]/70">You'll order and pay on TeaDM's Toast page for that store.</Dialog.Description>
          </div>
          <Dialog.Close data-testid="order-modal-close" className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-[#1a0a10] text-[#fff5e8] transition-transform hover:rotate-90" aria-label="Close">
            <X className="h-5 w-5" />
          </Dialog.Close>
        </div>
        <div className="space-y-3">
          {TEADM_STORES.map((l, i) => <StoreRow key={l.slug} loc={l} i={i} />)}
        </div>
        <a href={LINKS.toastHub} target="_blank" rel="noopener noreferrer" data-testid="order-modal-toast-hub" className="mt-6 block text-center text-sm font-semibold underline underline-offset-4">
          Not sure? Find the closest store on Toast
        </a>
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
